import {gql} from "@apollo/client";
import useWrappedMutation from "../common/data-fetching/useWrappedMutation";

const QUERY_SCOPE = "employer";
const QUERY_NAME = "employerCreate";

export const QUERY = gql`
    mutation ${QUERY_SCOPE}_${QUERY_NAME} (
       $firstName: String!,
       $lastName: String!,
       $email: String!
       $company: String!,
       $defaultLanguage: EmployerLanguageEnum
    ) {
      ${QUERY_SCOPE} {
        _id
        ${QUERY_NAME} (
          firstName: $firstName,
          lastName: $lastName,
          email: $email,
          company: $company,
          defaultLanguage: $defaultLanguage,
        ) {
          _id
          organization {
            _id
          }   
        }
      }
    }
  `;

export default function useMutationEmployerAdd() {

  return useWrappedMutation(QUERY, QUERY_SCOPE, QUERY_NAME);
}
